import styled from 'styled-components';

export const PublicationDateContainer = styled.div`
  opacity: 0.5;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.fontSize.sm};

  &.right-column {
    margin-left: 8px;

    @media (max-width: 1024px) {
      margin-left: 0px;
    }
  }
`;
